import model from "@js/model.js";
import controller from "@js/controller/controller.js";
import { nextTick, ref } from "vue"
import Enum from "@shared/enum.js";
import { LoginTitle2, LostPasswordText, RegisterNowLabel, TestOurGamesText } from "@lang/login.js";
import { PasswordLabel } from "@lang/register.js";

const username = ref(model.observables?.storedUsername || null);
const password = ref(null);

controller.onInitialized(() => {
	if(model.observables.storedUsername) username.value = model.observables.storedUsername;
});

function onOpenLoginLost() {
	controller.goTo(Enum.UIContexts.LOGIN_FORGOTTEN_PASSWORD);
}

function onSubmitLogin() {
	controller.destroyAllGames();
	if (username.value.length && password.value.length) {
		controller.sendLoginRequest(username.value, password.value);

		if(!model.observables.storedUsername) username.value = '';
		password.value = '';
	}
}

function onOpenRegister() {
	controller.goTo(Enum.UIContexts.REGISTER);
}

function onTestOurGames() {
	controller.closeAllModals();
	model.dispatchEvent('HideMobileNav');
}

model.pushLang({TestOurGamesText, RegisterNowLabel, LostPasswordText, LoginTitle2, PasswordLabel});
model.on('LoginOpen', e => {
	nextTick(() => {
		model.dispatchEvent('ForceResize');
	});
});

model.on('LoginClose', e => {
	controller.unsetGameAfterLogin();
	controller.unsetRedirUserAfterLogin();
	model.dispatchEvent('ForceResize');
	if(!model.observables.storedUsername) username.value = '';
	password.value = '';
});

export {
	username,
	password,
	onOpenLoginLost,
	onSubmitLogin,
	onOpenRegister,
	onTestOurGames,
};